import axios from 'axios';
import { retrieveAccessToken } from '../../../../shared/infra/auth/RetrieveAccessToken';

export async function findPlaygroundDraft() {
    const accessToken = await retrieveAccessToken();
    const response = await axios.get('/api/playground/draft', {
        headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : {},
    });
    return response.data;
}
